export default (stringifiedJSON) => JSON.parse(stringifiedJSON || "{}");
